import React from "react";

const FileIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7145 30H6.429C4.72392 30 3.08868 29.3227 1.88301 28.117C0.677339 26.9113 0 25.2761 0 23.571V6.429C0 4.72392 0.677339 3.08868 1.88301 1.88301C3.08868 0.677339 4.72392 0 6.429 0H12.441C13.7123 0.000285963 14.9403 0.461849 15.897 1.299L21.3495 6.069C21.913 6.56182 22.3647 7.16946 22.6741 7.85116C22.9835 8.53287 23.1436 9.27286 23.1435 10.0215V23.571C23.1435 24.4153 22.9772 25.2513 22.6541 26.0313C22.331 26.8113 21.8575 27.52 21.2605 28.117C20.6635 28.714 19.9548 29.1875 19.1748 29.5106C18.3948 29.8337 17.5588 30 16.7145 30ZM16.7145 27H6.429C5.9787 27 5.5328 26.9113 5.11678 26.739C4.70075 26.5667 4.32274 26.3141 4.00433 25.9957C3.68592 25.6773 3.43334 25.2992 3.26102 24.8832C3.08869 24.4672 3 24.0213 3 23.571V6.429C3 5.51957 3.36127 4.64739 4.00433 4.00433C4.64739 3.36127 5.51957 3 6.429 3H12.441C12.9856 3.00022 13.5116 3.19794 13.9215 3.5565L19.374 8.3265C19.6158 8.53777 19.8095 8.79833 19.9423 9.09069C20.075 9.38305 20.1436 9.70043 20.1435 10.0215V23.571C20.1435 24.0213 20.0548 24.4672 19.8825 24.8832C19.7102 25.2992 19.4576 25.6773 19.1392 25.9957C18.8208 26.3141 18.4427 26.5667 18.0267 26.739C17.6107 26.9113 17.1648 27 16.7145 27Z"
        fill="#DDB100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 1.5C13.8978 1.5 14.2794 1.65804 14.5607 1.93934C14.842 2.22064 15 2.60218 15 3V7.5C15 7.89782 15.158 8.27936 15.4393 8.56066C15.7206 8.84196 16.1022 9 16.5 9H20.25C20.6478 9 21.0294 9.15804 21.3107 9.43934C21.592 9.72064 21.75 10.1022 21.75 10.5C21.75 10.8978 21.592 11.2794 21.3107 11.5607C21.0294 11.842 20.6478 12 20.25 12H16.5C15.3065 12 14.1619 11.5259 13.318 10.682C12.4741 9.83807 12 8.69347 12 7.5V3C12 2.60218 12.158 2.22064 12.4393 1.93934C12.7206 1.65804 13.1022 1.5 13.5 1.5Z"
        fill="#DDB100"
      />
    </svg>
  );
};

export default FileIcon;
